import { RouteObject } from 'react-router-dom';
import MdmConfig from '../components/MdmConfig';

const routes: RouteObject[] = [
  {
    path: 'mdm-config',
    element: <MdmConfig />,
  },
];

export default routes; 